import store from '@/store';
import Vue from 'vue';
import AxiosService, { status } from '@/services/AxiosService';
import {
  SET_TOKEN,
  START_LOADING,
  END_LOADING,
} from '@/store/mutation-types';

export default () => {
  const apiWrapper = {};

  function processData(data) {
    const childEntities = {
      PayDetail: {
        map: 'bills',
        parentId: 'bill',
        property: 'payDetails',
        id: 'id',
      },
      BillItem: {
        map: 'bills',
        parentId: 'bill',
        property: 'billItems',
        id: 'id',
      },
    };
    if (data && data.insert) {
      data.delete.forEach((object) => {
        if (Object.keys(childEntities).indexOf(object.class) == -1) {
          store.dispatch('deleteObject', object);
        }
      });
      data.insert.forEach((object) => {
        if (Object.keys(childEntities).indexOf(object.class) == -1) {
          store.dispatch('saveObject', object);
        } else {
          const childEntity = childEntities[object.class];
          store
            .getters
            .getMap(childEntity.map)
            [object[childEntity.parentId]]
            [childEntity.property].push(object);
        }
      });
      data.update.forEach((object) => {
        if (object.class != 'PayDetail' && object.class != 'Stock') {
          const oldObject = store.getters.getObjectFromApi(object);
          if (oldObject) {
            oldObject.class = object.class;
            for (const property in object.changes) {
              oldObject[property] = object.changes[property][1];
            }
            store.dispatch('updateObject', oldObject);
          }
        }
      });
    }
  }
  apiWrapper.post = function (url, data, inline = false, contentType = 'application/json') {
    if(url !== '/ping') {
      store.commit(START_LOADING);
    }
    return AxiosService(inline, contentType)
      .post(url, data)
      .then((response) => {
        if (response.headers['x-pos-password-encrypted']) {
          store.commit(
            SET_TOKEN,
            {
              ...response.data,
              token: response.headers['x-pos-password-encrypted'],
            },
          );
        }
        processData(response.data);
        return response.data;
      })
      .catch((error) => {
        console.log('Error API CALL ----------', error);
        if (inline) {
          return error;
        }
      })
      .finally(() => { 
        if(url !== '/ping') {
          store.commit(END_LOADING); 
        }
      });
  };
  apiWrapper.put = function (url, data, inline = false, contentType = 'application/json') {
    store.commit(START_LOADING);
    return AxiosService(inline, contentType)
      .put(url, data)
      .then((response) => {
        processData(response.data);
        return response.data;
      })
      .catch((error) => {
        console.log('Error API CALL ----------', error);
        if (inline) {
          return error;
        }
      })
      .finally(() => { store.commit(END_LOADING); });
  };
  apiWrapper.patch = function (url, data, inline = false) {
    store.commit(START_LOADING);
    return AxiosService(inline)
      .patch(url, data)
      .then((response) => {
        processData(response.data);
        return response.data;
      })
      .catch((error) => {
        console.log('Error API CALL ----------', error);
        if (inline) {
          return error;
        }
      })
      .finally(() => { store.commit(END_LOADING); });
  };
  apiWrapper.get = function (url, inline = false, loading = false) {
    if (loading) {
      store.commit(START_LOADING);
    }
    return AxiosService(inline)
      .get(url)
      .then(response => response.data)
      .catch((error) => {
        console.log('Error API CALL ----------', error);
        if (inline) {
          return error;
        }
      })
      .finally(() => { if (loading) { store.commit(END_LOADING); } });
  };
  apiWrapper.status = status;
  apiWrapper.formData = (data) => {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (Array.isArray(data[key])) {
        if (data[key].length > 0) {
          formData.append(key, data[key]);
        }
      } else if (data[key]) {
        formData.append(key, data[key]);
      }
    });
    return formData;
  };
  return apiWrapper;
};
